import { Link } from "react-router-dom";

import { useTheme } from "../context/ThemeContext";

export function BrandLogo({ compact = false, showProduct = true }: { compact?: boolean; showProduct?: boolean }) {
  const { resolvedTheme } = useTheme();

  return (
    <Link className={`brand-logo${compact ? " brand-logo--compact" : ""}`} to="/" aria-label={showProduct ? "Next-Cart Support home" : "Next-Cart home"}>
      <span className="brand-logo__image">
        <img
          className={`brand-logo__asset${resolvedTheme === "light" ? " brand-logo__asset--active" : ""}`}
          src="/logo-nextcart-light.svg"
          alt=""
          aria-hidden="true"
          width="165"
          height="40"
          loading="eager"
          fetchPriority="high"
          draggable={false}
        />
        <img
          className={`brand-logo__asset${resolvedTheme === "dark" ? " brand-logo__asset--active" : ""}`}
          src="/logo-nextcart-dark.svg"
          alt=""
          aria-hidden="true"
          width="165"
          height="40"
          loading="eager"
          fetchPriority="high"
          draggable={false}
        />
      </span>
      {!compact && showProduct && (
        <span className="brand-logo__suffix" aria-hidden="true">
          <span className="brand-logo__separator">/</span>
          <span className="brand-logo__product">Support</span>
        </span>
      )}
    </Link>
  );
}
